import { interestConfig } from '../../../interestsConfig';

export const MIN_TOPICS_LENGTH = 1;
export const MAX_TOPICS_LENGTH = 5;

export const formFields = {
  FIRST_NAME: 'FIRST_NAME',
  LAST_NAME: 'LAST_NAME',
  ADDRESS1: 'ADDRESS1',
  ADDRESS2: 'ADDRESS2',
  CITY: 'CITY',
  POST_CODE: 'POST_CODE',
  PHONE_NUMBER: 'PHONE_NUMBER',
  COUNTRY: 'COUNTRY',
  INTERESTS: 'INTERESTS',
};

export const defaultDetails = {
  firstName: '',
  lastName: '',
  address1: '',
  address2: '',
  city: '',
  postCode: '',
  phone: '',
  country: '',
  interests: interestConfig,
};
